export default __webpack_public_path__ + "static/media/birthdayBanner.8692cf1f.jpg";